<template>
  <common-dialog ref="dialog" width="600px" title="订单评价" id-key="id" :data="data" :form-rules="rules"
    :save-func="saveDataFunc" @closed="onClosed" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="星级" label-width="90px">
        <el-select v-model="data.model.starLevel" :clearable="false">
          <el-option label="五星" value="5"></el-option>
          <el-option label="四星" value="4"></el-option>
          <el-option label="三星" value="3"></el-option>
          <el-option label="二星" value="2"></el-option>
          <el-option label="一星" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="评价内容" label-width="90px" prop="model.content">
        <el-input type="textarea" v-model="data.model.content"></el-input>
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/wx/order').default,
      data: {
        id: 0,
        model: {
          starLevel: "5",
          content: ""
        }
      },
      rules: {
        'model.content': [{ required: true, message: '评价内容不能为空' }],
      },
    };
  },
  mounted() { },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.batchSubmitRate(this.data).then(res => {
          if (res.failedOrderIds && res.failedOrderIds.length > 0) {
            resolve({ Code: 1, Msg: res.failedOrders[res.failedOrderIds[0]] })
          } else {
            resolve({ Code: 0, Msg: null })
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    onClosed() {
      this.data.model.starLevel = "5";
      this.data.model.content = "";
      this.$refs.dialog.clearValidate();
    }
  },
};
</script>
